import React, { FC, ReactNode, useCallback } from "react";

import { faChartLine } from "@fortawesome/pro-solid-svg-icons/faChartLine";
import { faGauge } from "@fortawesome/pro-solid-svg-icons/faGauge";
import { faMap } from "@fortawesome/pro-solid-svg-icons/faMap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import cn from "classnames";

import CardType from "@app/enum/dashboard/CardType";

import styles from "./CardItem.module.scss";

const icons = {
  chart: faChartLine,
  map: faMap,
  monitor: faGauge,
};

export interface CardItemProps {
  description: string;
  extra?: ReactNode;
  icon: keyof typeof icons;
  onClick?: (cardType: CardType) => void;
  selected?: boolean;
  title: string;
  type: CardType;
}

const CardItem: FC<CardItemProps> = ({
  description,
  extra,
  icon,
  onClick,
  selected,
  title,
  type,
}) => {
  const handleClick = useCallback(() => onClick?.(type), [onClick, type]);
  return (
    <div
      className={cn(styles.container, {
        [styles.clickable]: !!onClick,
        [styles.selected]: selected,
      })}
      onClick={handleClick}
    >
      <div>
        <div className={styles.title}>
          {title}
          {extra}
        </div>
        <div className={styles.description}>{description}</div>
      </div>
      <div className={styles.iconContainer}>
        <FontAwesomeIcon icon={icons[icon]} />
      </div>
    </div>
  );
};

export default CardItem;
